import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function CTA() {
  return <Section id="contact" className="bg-slate-900 text-white relative overflow-hidden" data-id="element-29">
      {/* Abstract background shapes */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-emerald-900/10 transform skew-x-12 translate-x-1/4" data-id="element-30"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-slate-800/30 transform -skew-x-12 -translate-x-1/4" data-id="element-31"></div>

      <div className="relative z-10 text-center max-w-3xl mx-auto py-12" data-id="element-32">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tight text-slate-100" data-id="element-33">
          Effizienz schaffen. <br data-id="element-34" />
          Vertrieb neu denken.
        </h2>
        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-35">
          Lassen Sie uns gemeinsam Ihren Vertrieb auf das nächste Level bringen.
          Vereinbaren Sie jetzt ein unverbindliches Erstgespräch.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-36">
          <Button variant="secondary" size="lg" icon data-id="element-37">
            Gespräch anfragen
          </Button>
          <Button variant="outline" size="lg" className="border-slate-600 text-slate-200 hover:bg-slate-800 hover:text-white hover:border-slate-500" data-id="element-38">
            E-Mail schreiben
          </Button>
        </div>
      </div>
    </Section>;
}